import _defineProperty from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React from 'react';
import { Text } from '../../Text/Text.js';
import { Divider } from '../../Divider/Divider.js';
import useStyles from './SelectItems.styles.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

function SelectItems(_ref) {
  var data = _ref.data,
      hovered = _ref.hovered,
      classNames = _ref.classNames,
      styles = _ref.styles,
      isItemSelected = _ref.isItemSelected,
      uuid = _ref.uuid,
      __staticSelector = _ref.__staticSelector,
      onItemHover = _ref.onItemHover,
      onItemSelect = _ref.onItemSelect,
      itemsRefs = _ref.itemsRefs,
      Item = _ref.itemComponent,
      size = _ref.size,
      nothingFound = _ref.nothingFound,
      creatable = _ref.creatable,
      createLabel = _ref.createLabel;

  var _useStyles = useStyles({
    size: size
  }, {
    classNames: classNames,
    styles: styles,
    name: __staticSelector
  }),
      classes = _useStyles.classes,
      cx = _useStyles.cx;

  var unGroupedItems = [];
  var groupedItems = [];
  var creatableDataIndex = null;

  var constructItemComponent = function constructItemComponent(item, index) {
    var _cx;

    var selected = typeof isItemSelected === "function" ? isItemSelected(item.value) : false;
    return /* @__PURE__ */React.createElement(Item, __spreadValues({
      key: item.value,
      className: cx(classes.item, (_cx = {}, _defineProperty(_cx, classes.hovered, !item.disabled && hovered === index), _defineProperty(_cx, classes.selected, !item.disabled && selected), _defineProperty(_cx, classes.disabled, item.disabled), _cx)),
      onMouseEnter: function onMouseEnter() {
        return onItemHover(index);
      },
      id: "".concat(uuid, "-").concat(index),
      role: "option",
      "data-ignore-outside-clicks": true,
      tabIndex: -1,
      "aria-selected": hovered === index,
      ref: function ref(node) {
        if (itemsRefs && itemsRefs.current) {
          itemsRefs.current[item.value] = node;
        }
      },
      onMouseDown: !item.disabled ? function (event) {
        event.preventDefault();
        onItemSelect(item);
      } : null,
      disabled: item.disabled
    }, item));
  };

  var groupName = null;
  data.forEach(function (item, index) {
    if (item.creatable) {
      creatableDataIndex = index;
    } else if (!item.group) {
      unGroupedItems.push(constructItemComponent(item, index));
    } else {
      if (groupName !== item.group) {
        groupName = item.group;
        groupedItems.push( /* @__PURE__ */React.createElement("div", {
          className: classes.separator,
          key: "__mantine-divider-".concat(index)
        }, /* @__PURE__ */React.createElement(Divider, {
          classNames: {
            label: classes.separatorLabel
          },
          label: item.group
        })));
      }

      groupedItems.push(constructItemComponent(item, index));
    }
  });

  if (creatable) {
    var _cx2;

    var creatableDataItem = data[creatableDataIndex];
    var selected = typeof isItemSelected === "function" ? isItemSelected(data[creatableDataIndex].value) : false;
    unGroupedItems.push( /* @__PURE__ */React.createElement("div", {
      key: creatableDataItem.value,
      className: cx(classes.item, (_cx2 = {}, _defineProperty(_cx2, classes.hovered, hovered === creatableDataIndex), _defineProperty(_cx2, classes.selected, selected), _cx2)),
      onMouseEnter: function onMouseEnter() {
        return onItemHover(creatableDataIndex);
      },
      onMouseDown: function onMouseDown(event) {
        event.preventDefault();
        onItemSelect(creatableDataItem);
      },
      tabIndex: -1,
      ref: function ref(node) {
        if (itemsRefs && itemsRefs.current) {
          itemsRefs.current[creatableDataItem.value] = node;
        }
      }
    }, createLabel));
  }

  if (groupedItems.length > 0 && unGroupedItems.length > 0) {
    unGroupedItems.unshift( /* @__PURE__ */React.createElement("div", {
      className: classes.separator
    }, /* @__PURE__ */React.createElement(Divider, null)));
  }

  return groupedItems.length > 0 || unGroupedItems.length > 0 ? /* @__PURE__ */React.createElement(React.Fragment, null, groupedItems, unGroupedItems) : /* @__PURE__ */React.createElement(Text, {
    size: size,
    className: classes.nothingFound
  }, nothingFound);
}

SelectItems.displayName = "@mantine/core/SelectItems";
export { SelectItems };